import RemovePerson from './RemovePerson';
export { RemovePerson };
export default RemovePerson;
